import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryDispatchApprovalEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryDispatchApprovalContentProps = {
  event: OrderDetailsHistoryEntryDispatchApprovalEvent;
};

const OrderDetailsHistoryEntryDispatchApprovalContentComponent: FC<
  OrderDetailsHistoryEntryDispatchApprovalContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .dispatchApprovalEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryDispatchApprovalContentComponent;
